var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('abbr',{attrs:{"title":(_vm.title + " (Click for Glossary)")},on:{"click":function($event){$event.stopPropagation();return _vm.onClickAbbr($event)}}},[(!_vm.full)?_vm._t("default"):_c('span',[_vm._v(_vm._s(_vm.title))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }